module.exports = __webpack_public_path__ + "static/media/logo.c37dde96.png";